module.exports = __webpack_public_path__ + "img/ic_sales_left.73f40007.png";